import { RouterProvider } from "react-router-dom";

import { ErrorBoundary, Spinner } from "@app/components";
import { router } from "@app/routes";
import { getUxMode } from "@app/routes/app-paths";
import { StylesReset } from "@app/styles";
import { getEnvConfig } from "@app/utils";
import { FaroErrorBoundary } from "@grafana/faro-react";
import { UserStateProvider } from "@honeycomb/api";
import { PusherProvider, ThemeProvider } from "@honeycomb/mystique";
import { FlagProvider } from "@unleash/proxy-client-react";

import { initializeTelemtry } from "./telemetry";

initializeTelemtry();

export const App = () => {
  const env = getEnvConfig();
  const uxMode = getUxMode();
  const unleashConfig = {
    url: env.UNLEASH_URL,
    clientKey: env.UNLEASH_TOKEN,
    refreshInterval: 1800,
    appName: "honeycomb",
    environment: env.UNLEASH_ENV,
  };

  return (
    <FaroErrorBoundary>
      <ErrorBoundary>
        <StylesReset />
        <ThemeProvider disabled={uxMode === "classic"}>
          <UserStateProvider>
            <FlagProvider config={unleashConfig}>
              <PusherProvider>
                <RouterProvider router={router} fallbackElement={<Spinner />} />
              </PusherProvider>
            </FlagProvider>
          </UserStateProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </FaroErrorBoundary>
  );
};
